import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { Schedule } from './Info'

export { Schedule as LoanSchedule }

export default Loadable(() => import('./LoanDetails'))
